var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppInputField',{staticClass:"radio"},[_c('input',_vm._b({staticClass:"app-input",domProps:{"value":_vm.value},on:{"input":_vm.updateValue}},'input',_vm.$attrs,false)),(_vm.label)?_c('label',{attrs:{"for":_vm.$attrs.id}},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }